import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ee4aadc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "workout-map" }
const _hoisted_2 = {
  key: 0,
  class: "leaflet-container"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "leaflet-container"
}
const _hoisted_5 = {
  key: 1,
  class: "no-map"
}

import { gpx } from '@tmcw/togeojson'
  import { LGeoJson, LMap, LMarker, LTileLayer } from '@vue-leaflet/vue-leaflet'
  import { ComputedRef, computed, ref, toRefs, withDefaults } from 'vue'

  import { ROOT_STORE } from '@/store/constants'
  import { TAppConfig } from '@/types/application'
  import { GeoJSONData } from '@/types/geojson'
  import { IWorkoutData, TCoordinates } from '@/types/workouts'
  import { useStore } from '@/use/useStore'
  import { getApiUrl } from '@/utils'

  interface Props {
    workoutData: IWorkoutData
    markerCoordinates?: TCoordinates
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    workoutData: null,
    markerCoordinates: { default: () => ({} as TCoordinates) }
  },
  setup(__props: any) {

const props = __props as { workoutData: IWorkoutData, markerCoordinates: TCoordinates }

  

  const store = useStore()

  const { workoutData, markerCoordinates } = toRefs(props)
  const workoutMap = ref<null | {
    leafletObject: { fitBounds: (bounds: number[][]) => null }
  }>(null)
  const bounds = computed(() =>
    props.workoutData
      ? [
          [
            props.workoutData.workout.bounds[0],
            props.workoutData.workout.bounds[1],
          ],
          [
            props.workoutData.workout.bounds[2],
            props.workoutData.workout.bounds[3],
          ],
        ]
      : []
  )
  const appConfig: ComputedRef<TAppConfig> = computed(
    () => store.getters[ROOT_STORE.GETTERS.APP_CONFIG]
  )
  const center = computed(() => getCenter(bounds))
  const geoJson = computed(() =>
    props.workoutData && props.workoutData.gpx
      ? getGeoJson(props.workoutData.gpx)
      : {}
  )

  function getGeoJson(gpxContent: string): GeoJSONData {
    if (!gpxContent || gpxContent !== '') {
      try {
        const jsonData = gpx(
          new DOMParser().parseFromString(gpxContent, 'text/xml')
        )
        return { jsonData }
      } catch (e) {
        console.error('Invalid gpx content')
        return {}
      }
    }
    return {}
  }
  function getCenter(bounds: ComputedRef<number[][]>): number[] {
    return [
      (bounds.value[0][0] + bounds.value[1][0]) / 2,
      (bounds.value[0][1] + bounds.value[1][1]) / 2,
    ]
  }
  function fitBounds(bounds: number[][]) {
    if (workoutMap.value?.leafletObject) {
      workoutMap.value?.leafletObject.fitBounds(bounds)
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(workoutData).loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_unref(workoutData).workout.with_gpx)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_unref(geoJson).jsonData && _unref(center) && _unref(bounds).length === 2)
                  ? (_openBlock(), _createBlock(_unref(LMap), {
                      key: 0,
                      zoom: 13,
                      center: _unref(center),
                      bounds: _unref(bounds),
                      ref: (_value, _refs) => {
                        _refs['workoutMap'] = _value
                        workoutMap.value = _value
                      },
                      onReady: _cache[0] || (_cache[0] = ($event: any) => (fitBounds(_unref(bounds))))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(LTileLayer), {
                          url: `${_unref(getApiUrl)()}workouts/map_tile/{s}/{z}/{x}/{y}.png`,
                          attribution: _unref(appConfig).map_attribution,
                          bounds: _unref(bounds)
                        }, null, 8, ["url", "attribution", "bounds"]),
                        _createVNode(_unref(LGeoJson), {
                          geojson: _unref(geoJson).jsonData
                        }, null, 8, ["geojson"]),
                        (_unref(markerCoordinates).latitude)
                          ? (_openBlock(), _createBlock(_unref(LMarker), {
                              key: 0,
                              "lat-lng": [_unref(markerCoordinates).latitude, _unref(markerCoordinates).longitude]
                            }, null, 8, ["lat-lng"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["center", "bounds"]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('workouts.NO_MAP')), 1))
        ]))
  ]))
}
}

})